import { JSX } from 'react'

import { IconProps } from '../../icon'

const Dashboard: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M36.5714 22.8572H28.5714C27.9406 22.8572 27.4286 22.3452 27.4286 21.7143C27.4286 21.0834 27.9406 20.5714 28.5714 20.5714H36.5714C37.2023 20.5714 37.7143 21.0834 37.7143 21.7143C37.7143 22.3452 37.2023 22.8572 36.5714 22.8572Z'
      fill='black'
    />
    <path
      d='M26.2857 20.5714C25.6549 20.5714 25.1429 20.0594 25.1429 19.4286V11.4286C25.1429 10.7977 25.6549 10.2857 26.2857 10.2857C26.9166 10.2857 27.4286 10.7977 27.4286 11.4286V19.4286C27.4286 20.0594 26.9166 20.5714 26.2857 20.5714Z'
      fill='black'
    />
    <path
      d='M28.5714 22.8571C26.6806 22.8571 25.1429 21.3194 25.1429 19.4286C25.1429 18.7977 25.6549 18.2857 26.2857 18.2857C26.9166 18.2857 27.4286 18.7977 27.4286 19.4286C27.4286 20.0588 27.9411 20.5714 28.5714 20.5714C29.2023 20.5714 29.7143 21.0834 29.7143 21.7143C29.7143 22.3451 29.2023 22.8571 28.5714 22.8571Z'
      fill='black'
    />
    <path
      d='M38.8571 20.5714C38.2263 20.5714 37.7143 20.0594 37.7143 19.4286V11.4286C37.7143 10.7977 38.2263 10.2857 38.8571 10.2857C39.488 10.2857 40 10.7977 40 11.4286V19.4286C40 20.0594 39.488 20.5714 38.8571 20.5714Z'
      fill='black'
    />
    <path
      d='M36.5714 10.2857H28.5714C27.9406 10.2857 27.4286 9.77371 27.4286 9.14286C27.4286 8.512 27.9406 8 28.5714 8H36.5714C37.2023 8 37.7143 8.512 37.7143 9.14286C37.7143 9.77371 37.2023 10.2857 36.5714 10.2857Z'
      fill='black'
    />
    <path
      d='M36.5714 22.8571C35.9406 22.8571 35.4286 22.3451 35.4286 21.7143C35.4286 21.0834 35.9406 20.5714 36.5714 20.5714C37.2017 20.5714 37.7143 20.0588 37.7143 19.4286C37.7143 18.7977 38.2263 18.2857 38.8571 18.2857C39.488 18.2857 40 18.7977 40 19.4286C40 21.3194 38.4623 22.8571 36.5714 22.8571Z'
      fill='black'
    />
    <path
      d='M26.2857 12.5714C25.6549 12.5714 25.1429 12.0594 25.1429 11.4286C25.1429 9.53771 26.6806 8 28.5714 8C29.2023 8 29.7143 8.512 29.7143 9.14286C29.7143 9.77371 29.2023 10.2857 28.5714 10.2857C27.9411 10.2857 27.4286 10.7983 27.4286 11.4286C27.4286 12.0594 26.9166 12.5714 26.2857 12.5714Z'
      fill='black'
    />
    <path
      d='M26.2857 29.7143C25.6549 29.7143 25.1429 29.2023 25.1429 28.5714C25.1429 26.6806 26.6806 25.1429 28.5714 25.1429C29.2023 25.1429 29.7143 25.6549 29.7143 26.2857C29.7143 26.9166 29.2023 27.4286 28.5714 27.4286C27.9411 27.4286 27.4286 27.9411 27.4286 28.5714C27.4286 29.2023 26.9166 29.7143 26.2857 29.7143Z'
      fill='black'
    />
    <path
      d='M26.2857 37.7143C25.6549 37.7143 25.1429 37.2023 25.1429 36.5714V28.5714C25.1429 27.9406 25.6549 27.4286 26.2857 27.4286C26.9166 27.4286 27.4286 27.9406 27.4286 28.5714V36.5714C27.4286 37.2023 26.9166 37.7143 26.2857 37.7143Z'
      fill='black'
    />
    <path
      d='M36.5714 27.4286H28.5714C27.9406 27.4286 27.4286 26.9166 27.4286 26.2857C27.4286 25.6549 27.9406 25.1429 28.5714 25.1429H36.5714C37.2023 25.1429 37.7143 25.6549 37.7143 26.2857C37.7143 26.9166 37.2023 27.4286 36.5714 27.4286Z'
      fill='black'
    />
    <path
      d='M38.8571 29.7143C38.2263 29.7143 37.7143 29.2023 37.7143 28.5714C37.7143 27.9411 37.2017 27.4286 36.5714 27.4286C35.9406 27.4286 35.4286 26.9166 35.4286 26.2857C35.4286 25.6549 35.9406 25.1429 36.5714 25.1429C38.4623 25.1429 40 26.6806 40 28.5714C40 29.2023 39.488 29.7143 38.8571 29.7143Z'
      fill='black'
    />
    <path
      d='M38.8571 37.7143C38.2263 37.7143 37.7143 37.2023 37.7143 36.5714V28.5714C37.7143 27.9406 38.2263 27.4286 38.8571 27.4286C39.488 27.4286 40 27.9406 40 28.5714V36.5714C40 37.2023 39.488 37.7143 38.8571 37.7143Z'
      fill='black'
    />
    <path
      d='M36.5714 40C35.9406 40 35.4286 39.488 35.4286 38.8571C35.4286 38.2263 35.9406 37.7143 36.5714 37.7143C37.2017 37.7143 37.7143 37.2017 37.7143 36.5714C37.7143 35.9406 38.2263 35.4286 38.8571 35.4286C39.488 35.4286 40 35.9406 40 36.5714C40 38.4623 38.4623 40 36.5714 40Z'
      fill='black'
    />
    <path
      d='M36.5714 40H28.5714C27.9406 40 27.4286 39.488 27.4286 38.8572C27.4286 38.2263 27.9406 37.7143 28.5714 37.7143H36.5714C37.2023 37.7143 37.7143 38.2263 37.7143 38.8572C37.7143 39.488 37.2023 40 36.5714 40Z'
      fill='black'
    />
    <path
      d='M28.5714 40C26.6806 40 25.1429 38.4623 25.1429 36.5714C25.1429 35.9406 25.6549 35.4286 26.2857 35.4286C26.9166 35.4286 27.4286 35.9406 27.4286 36.5714C27.4286 37.2017 27.9411 37.7143 28.5714 37.7143C29.2023 37.7143 29.7143 38.2263 29.7143 38.8571C29.7143 39.488 29.2023 40 28.5714 40Z'
      fill='black'
    />
    <path
      d='M21.7143 29.7143C21.0834 29.7143 20.5714 29.2023 20.5714 28.5714C20.5714 27.9411 20.0589 27.4286 19.4286 27.4286C18.7977 27.4286 18.2857 26.9166 18.2857 26.2857C18.2857 25.6549 18.7977 25.1429 19.4286 25.1429C21.3194 25.1429 22.8571 26.6806 22.8571 28.5714C22.8571 29.2023 22.3451 29.7143 21.7143 29.7143Z'
      fill='black'
    />
    <path
      d='M21.7143 37.7143C21.0834 37.7143 20.5714 37.2023 20.5714 36.5714V28.5714C20.5714 27.9406 21.0834 27.4286 21.7143 27.4286C22.3451 27.4286 22.8571 27.9406 22.8571 28.5714V36.5714C22.8571 37.2023 22.3451 37.7143 21.7143 37.7143Z'
      fill='black'
    />
    <path
      d='M19.4286 27.4286H11.4286C10.7977 27.4286 10.2857 26.9166 10.2857 26.2857C10.2857 25.6549 10.7977 25.1429 11.4286 25.1429H19.4286C20.0594 25.1429 20.5714 25.6549 20.5714 26.2857C20.5714 26.9166 20.0594 27.4286 19.4286 27.4286Z'
      fill='black'
    />
    <path
      d='M9.14286 29.7143C8.512 29.7143 8 29.2023 8 28.5714C8 26.6806 9.53771 25.1429 11.4286 25.1429C12.0594 25.1429 12.5714 25.6549 12.5714 26.2857C12.5714 26.9166 12.0594 27.4286 11.4286 27.4286C10.7983 27.4286 10.2857 27.9411 10.2857 28.5714C10.2857 29.2023 9.77371 29.7143 9.14286 29.7143Z'
      fill='black'
    />
    <path
      d='M9.14286 37.7143C8.512 37.7143 8 37.2023 8 36.5714V28.5714C8 27.9406 8.512 27.4286 9.14286 27.4286C9.77371 27.4286 10.2857 27.9406 10.2857 28.5714V36.5714C10.2857 37.2023 9.77371 37.7143 9.14286 37.7143Z'
      fill='black'
    />
    <path
      d='M11.4286 40C9.53771 40 8 38.4623 8 36.5714C8 35.9406 8.512 35.4286 9.14286 35.4286C9.77371 35.4286 10.2857 35.9406 10.2857 36.5714C10.2857 37.2017 10.7983 37.7143 11.4286 37.7143C12.0594 37.7143 12.5714 38.2263 12.5714 38.8571C12.5714 39.488 12.0594 40 11.4286 40Z'
      fill='black'
    />
    <path
      d='M19.4286 40H11.4286C10.7977 40 10.2857 39.488 10.2857 38.8572C10.2857 38.2263 10.7977 37.7143 11.4286 37.7143H19.4286C20.0594 37.7143 20.5714 38.2263 20.5714 38.8572C20.5714 39.488 20.0594 40 19.4286 40Z'
      fill='black'
    />
    <path
      d='M19.4286 40C18.7977 40 18.2857 39.488 18.2857 38.8571C18.2857 38.2263 18.7977 37.7143 19.4286 37.7143C20.0589 37.7143 20.5714 37.2017 20.5714 36.5714C20.5714 35.9406 21.0834 35.4286 21.7143 35.4286C22.3451 35.4286 22.8571 35.9406 22.8571 36.5714C22.8571 38.4623 21.3194 40 19.4286 40Z'
      fill='black'
    />
    <path
      d='M38.8571 12.5714C38.2263 12.5714 37.7143 12.0594 37.7143 11.4286C37.7143 10.7983 37.2017 10.2857 36.5714 10.2857C35.9406 10.2857 35.4286 9.77371 35.4286 9.14286C35.4286 8.512 35.9406 8 36.5714 8C38.4623 8 40 9.53771 40 11.4286C40 12.0594 39.488 12.5714 38.8571 12.5714Z'
      fill='black'
    />
    <path
      d='M19.4286 22.8571C18.7977 22.8571 18.2857 22.3451 18.2857 21.7143C18.2857 21.0834 18.7977 20.5714 19.4286 20.5714C20.0589 20.5714 20.5714 20.0588 20.5714 19.4286C20.5714 18.7977 21.0834 18.2857 21.7143 18.2857C22.3451 18.2857 22.8571 18.7977 22.8571 19.4286C22.8571 21.3194 21.3194 22.8571 19.4286 22.8571Z'
      fill='black'
    />
    <path
      d='M21.7143 20.5714C21.0834 20.5714 20.5714 20.0594 20.5714 19.4286V11.4286C20.5714 10.7977 21.0834 10.2857 21.7143 10.2857C22.3451 10.2857 22.8571 10.7977 22.8571 11.4286V19.4286C22.8571 20.0594 22.3451 20.5714 21.7143 20.5714Z'
      fill='black'
    />
    <path
      d='M19.4286 22.8572H11.4286C10.7977 22.8572 10.2857 22.3452 10.2857 21.7143C10.2857 21.0834 10.7977 20.5714 11.4286 20.5714H19.4286C20.0594 20.5714 20.5714 21.0834 20.5714 21.7143C20.5714 22.3452 20.0594 22.8572 19.4286 22.8572Z'
      fill='black'
    />
    <path
      d='M11.4286 22.8571C9.53771 22.8571 8 21.3194 8 19.4286C8 18.7977 8.512 18.2857 9.14286 18.2857C9.77371 18.2857 10.2857 18.7977 10.2857 19.4286C10.2857 20.0588 10.7983 20.5714 11.4286 20.5714C12.0594 20.5714 12.5714 21.0834 12.5714 21.7143C12.5714 22.3451 12.0594 22.8571 11.4286 22.8571Z'
      fill='black'
    />
    <path
      d='M9.14286 20.5714C8.512 20.5714 8 20.0594 8 19.4286V11.4286C8 10.7977 8.512 10.2857 9.14286 10.2857C9.77371 10.2857 10.2857 10.7977 10.2857 11.4286V19.4286C10.2857 20.0594 9.77371 20.5714 9.14286 20.5714Z'
      fill='black'
    />
    <path
      d='M9.14286 12.5714C8.512 12.5714 8 12.0594 8 11.4286C8 9.53771 9.53771 8 11.4286 8C12.0594 8 12.5714 8.512 12.5714 9.14286C12.5714 9.77371 12.0594 10.2857 11.4286 10.2857C10.7983 10.2857 10.2857 10.7983 10.2857 11.4286C10.2857 12.0594 9.77371 12.5714 9.14286 12.5714Z'
      fill='black'
    />
    <path
      d='M19.4286 10.2857H11.4286C10.7977 10.2857 10.2857 9.77371 10.2857 9.14286C10.2857 8.512 10.7977 8 11.4286 8H19.4286C20.0594 8 20.5714 8.512 20.5714 9.14286C20.5714 9.77371 20.0594 10.2857 19.4286 10.2857Z'
      fill='black'
    />
    <path
      d='M21.7143 12.5714C21.0834 12.5714 20.5714 12.0594 20.5714 11.4286C20.5714 10.7983 20.0589 10.2857 19.4286 10.2857C18.7977 10.2857 18.2857 9.77371 18.2857 9.14286C18.2857 8.512 18.7977 8 19.4286 8C21.3194 8 22.8571 9.53771 22.8571 11.4286C22.8571 12.0594 22.3451 12.5714 21.7143 12.5714Z'
      fill='black'
    />
  </svg>
)

export default Dashboard
